import * as Sentry from '@sentry/browser';

import { ApplicationError } from 'utils/ApplicationError';

export const handleAudioAccessErr = (err: unknown): void => {
  Sentry.withScope(scope => {
    scope.setTag(
      'audioAccessError',
      'Error accessing audio, please try again shortly',
    );
    scope.setContext('audioAccessErrorContext', {
      error: err instanceof Error ? err.message : String(err),
    });
    Sentry.captureException(err);
  });

  throw new ApplicationError(
    'Error accessing audio, please try again shortly',
    'ER042',
  );
};
